import * as ko from "knockout";
import {IParams as ISwitchParams, viewModel as SwitchViewModel} from "./switch";
import boxyHtml from './boxy.html?raw';

export let template: string = boxyHtml;

export interface IParams extends ISwitchParams {
    indeterminate?: KnockoutObservable<boolean>
}

export class viewModel extends SwitchViewModel {
    private indeterminate: KnockoutObservable<boolean | null>;

    constructor(params: IParams) {
        super(params);
        this.indeterminate = (params.indeterminate ?? ko.observable<boolean | null>(null)) as KnockoutObservable<boolean | null>
    }
}
